import { Logger as ClientSideLogger } from './clientSideLogger';
import { ILogger } from './interface';
import { Logger as ServerSideLogger } from './serverSideLogger';
import { isServerSide } from '../serverSide';

export type Dependencies = typeof dependencies;

export const dependencies = {
  isServerSide,
  ServerSideLogger,
  ClientSideLogger,
};

export const loggerFactory = (overrides?: Dependencies) => {
  const deps = { ...dependencies, ...overrides };

  if (deps.isServerSide()) {
    return new deps.ServerSideLogger();
  } else {
    return new deps.ClientSideLogger();
  }
};

export const logger: ILogger = loggerFactory();
